import { createSlice } from "@reduxjs/toolkit";
import {
  addProcessorRamCapacity,
  fetchProcessorRamCapacity,
  fetchProcessorRamCapacityById,
  updateProcessorRamCapacity,
  updateStatusInProcessorRamCapacity,
} from "./thunk";

interface CategoryState {
  processor_ram_capacity_list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedCategories: any;
}

const initialState: CategoryState = {
  processor_ram_capacity_list: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedCategories: null,
};

const categorySlice = createSlice({
  name: "ram_capacity",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProcessorRamCapacity.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProcessorRamCapacity.fulfilled, (state, action) => {
        state.loading = false;
        state.processor_ram_capacity_list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchProcessorRamCapacity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Processor Threads";
      })
      .addCase(fetchProcessorRamCapacityById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProcessorRamCapacityById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedCategories = action.payload;
      })
      .addCase(fetchProcessorRamCapacityById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(addProcessorRamCapacity.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.processor_ram_capacity_list = state.processor_ram_capacity_list.map((ram_capacity) =>
          ram_capacity.id === action.payload.id ? action.payload : ram_capacity
        );
      })
      .addCase(addProcessorRamCapacity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update GP";
      })
      .addCase(updateProcessorRamCapacity.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.processor_ram_capacity_list = state.processor_ram_capacity_list.map((ram_capacity) =>
          ram_capacity.id === action.payload.id ? action.payload : ram_capacity
        );
      })
      .addCase(updateProcessorRamCapacity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update GP";
      })
      .addCase(updateStatusInProcessorRamCapacity.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        // state.categoryList = state.categoryList.map((category) =>
        //   category.id === action.payload.id ? action.payload : category
        // );
      })
      .addCase(updateStatusInProcessorRamCapacity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update status";
      });
  },
});

export default categorySlice.reducer;
